<template>
    <div>
        <section>
            <v-card-actions>
                <router-link to="/courses">
                    <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
                </router-link>
            </v-card-actions>
            <h1>{{ card.title }}</h1>
            <!-- Título y subtítulo             
            <h3>{{ card.subtitle }}</h3>-->
            <v-divider></v-divider>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-row>
                <v-col cols="12" md="12" lg="12">
                    <v-img class="align-end text-white" contain :style="{ 'max-width': '180vh', 'max-height': '50vh' }" :src="getImageSrc(card.images)"></v-img>
                </v-col>
            </v-row>
            <v-row>                
                <v-col cols="12" md="6" lg="11">
                    <p style="font-size: 50px; color: rgb(15, 135, 201);"><b>________________________________________________</b></p>
                    <!---->
                    <details @click="mostrarAdjuntosCategories(8)" open>
                        <summary id="cat8">
                            <p><b>E-learning</b></p>
                        </summary>
                        <div>
                            <p>
                                The UNODC <a href="https://www.unodc.org/elearning/en/courses/public.html" target="_blank">global eLearning platform</a> offers a number of self-paced online 
                                modules that are open to the public and free of charge. Anyone can access these modules after self-registering on the eLearning platform. Unless otherwise 
                                stated, a certificate will be issued upon the successful completion of a post-test. The following e-courses are available:<br><br>

                                <b><a href="https://elearningunodc.org/course/view.php?id=82" target="_blank">The Nelson Mandela Rules</a></b><br>
                                This course contains seven self-paced modules that will assist the user in understanding and applying the Nelson Mandela Rules as the universally acknowledge 
                                minimum standard for the management of prisons and the treatment of prisoners. It consists of an introduction, five substantive modules as well as a final assessment. 
                                Each substantive module consists of a theoretical and a practical part, the latter exposing the user to concrete prison management scenarios. Resource sections throughout 
                                the course provide references to more in-depth technical guidance material. The course has been primarily designed as a practical training tool for prison officers 
                                and other officials working in prisons. It will be equally relevant for prison monitoring and inspection bodies and other (non-) governmental entities promoting 
                                prison reform in the line with international standards and norms.<br>
                                Available in: 
                                <a href="https://elearningunodc.org/course/view.php?id=82" target="_blank">EN</a> - 
                                <a href="https://elearningunodc.org/course/view.php?id=87" target="_blank">ES</a> - 
                                <a href="https://elearningunodc.org/course/view.php?id=86" target="_blank">FR</a> - 
                                <a href="https://elearningunodc.org/course/view.php?id=95" target="_blank">PO</a>
                                Duration: 30 min. <br><br>

                                <b><a href="https://elearningunodc.org/course/view.php?id=37" target="_blank">Alternatives to Imprisonment for Women Offenders</a></b><br>
                                This self-paced module addresses gender-based discrimination in the criminal justice system and explains non-custodial measures that should be made available to women 
                                offenders in line with international standards and norms. This course was developed by UNODC and the Council of Europe for criminal justice practitioners.<br>
                                Please note that this module does not contain a post-test, and therefore no certificate will be issued.<br>
                                Available in: <a href="https://elearningunodc.org/course/view.php?id=37" target="_blank">EN</a> - Duration: 60 - 90 min.<br><br>

                                <b><a href="https://www.unicef.org/eca/reports/unicefs-training-package-child-friendly-legal-services" target="_blank">Child friendly legal aid</a></b><br>
                                UNICEF's Training Package for Child-Friendly Legal Services is an adaptable training package for lawyers and other legal service practitioners to develop their knowledge, 
                                attitudes and skills in delivering child-friendly legal services (advice, assistance and representation).<br>
                                Available in: <a href="https://www.unicef.org/eca/reports/unicefs-training-package-child-friendly-legal-services" target="_blank">EN</a> - Duration: 3 days.
                            </p>
                        </div>
                    </details>
                </v-col>
            </v-row>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {            
            nombresAdjuntos: [], nombresAdjuntos2: [], nombresAdjuntos3: [], nombresAdjuntos4: [],
            nombresAdjuntos5: [], nombresAdjuntos6: [], nombresAdjuntos7: [], nombresAdjuntos8: [],
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                additionalInfo2: '',
                images: [],
                chip: [],
            },
            cards: [
                {
                    id: 6,
                    title: 'PRISON REFORM',
                    subtitle: 'UNODC',
                    category: '<p><b></p></b>'+
                        '<ul>'+
                            '<li><a href="#cat1" style="text-decoration: none;">6.1. Prison Reform</a></li>'+
                                '<ul>'+
                                    '<li>6.1.1. Introduction</li>'+
                                    '<li>6.1.2. Table of Contents</li>'+
                                    '<li>6.1.3. Tools in the Spotlight</li>'+
                                    '<li><a href="#cat1_4" style="text-decoration: none;">6.1.4. Global Data</a></li>'+
                                    '<li><a href="#cat1_5" style="text-decoration: none;">6.1.5. Regional Data</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat2" style="text-decoration: none;">6.2. International Standards</a></li>'+                            
                            '<li><a href="#cat3" style="text-decoration: none;">6.3. Key UN and Other Actors</a></li>'+
                            '<li><a href="#cat4" style="text-decoration: none;">6.4. UN Common Position on Incarceration</a></li>'+
                            '<li><a href="#cat5" style="text-decoration: none;">6.5. United Nations Priority Areas</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat5_1" style="text-decoration: none;">6.5.1. Shifting Policies Towards Prevention and Alternative to Incarceration - Tools and Resources</a></li>'+
                                    '<li><a href="#cat5_2" style="text-decoration: none;">6.5.2. Strengthening Prison Management and Improve Prison Conditions – Tools and Resources</a></li>'+
                                    '<li><a href="#cat5_3" style="text-decoration: none;">6.5.3. Investing in Prevention of Recidivism by Advancing Rehabilitation and Social Reintegration – Tools and Resources</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat6" style="text-decoration: none;">6.6. United Nations Directions of Action</a></li>'+
                            '<li><a href="#cat7" style="text-decoration: none;">6.7. Suggested Practical Steps for Action</a></li>'+
                                '<ul>'+
                                    '<li><a href="#cat7_1" style="text-decoration: none;">6.7.1.	Ensure that the Topic of Incarceration Remains High on the Political Agenda</a></li>'+
                                    '<li><a href="#cat7_2" style="text-decoration: none;">6.7.2.	Enhance United Nations Advocacy Efforts in Support of Member States</a></li>'+
                                    '<li><a href="#cat7_3" style="text-decoration: none;">6.7.3.	Strengthen United Nations Capacity to Respond to Requests for Policy Advice and Technical Assistance</a></li>'+
                                    '<li><a href="#cat7_4" style="text-decoration: none;">6.7.4.	Enhancing Prison Support in United Nations Field Missions and Other Crisis Settings</a></li>'+
                                    '<li><a href="#cat7_5" style="text-decoration: none;">6.7.5.	Strengthen Partnerships with International Organizations and Civil Society</a></li>'+
                                '</ul>'+
                            '<li><a href="#cat8" style="text-decoration: none;">6.8. E-learning</a></li>'+
                        '</ul>',
                    additionalInfo: 'Additional Info',
                    additionalInfo2: 'The prison system is in a situation of crisis at the global level and in Latin America and the Caribbean, the effects of which harm prisoners, their families and societies as a whole. The reality in many prisons tends to be not only far from international standards, but also risks undermining the ultimate purpose of a sentence of imprisonment: the protection of society from crime and the prevention of recidivism by supporting rehabilitation and preparing prisoners for their social reintegration upon release. ',
                    description: '',                    
                    images: ['6.jpg'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
            ],
        };  
    },
    methods: {
        descargarArchivo(nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarPrison/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarPrison/${nombreArchivo}`;//local
            
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('target', '_blank'); // Para abrir el archivo en una nueva pestaña
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        descargarCategory(id, nombreArchivo) {
            //const url = `https://localhost:7254/api/Categories/MostrarSoporte6/${id}/${nombreArchivo}`;//local
            const url = `https://unlabccback.rocol.org/api/Categories/MostrarSoporte6/${id}/${nombreArchivo}`;//local
            // Extraer la extensión del archivo
            const extension = nombreArchivo.split('.').pop().toLowerCase();

            // Crear una solicitud HTTP
            const xhr = new XMLHttpRequest();

            // Configurar la solicitud
            xhr.open('GET', url, true);
            xhr.responseType = 'blob'; // Establecer el tipo de respuesta como blob (Binary Large Object)

            // Configurar la gestión de la carga
            xhr.onload = function () {
                if (xhr.status === 200) {
                    // Crear un objeto Blob con el contenido de la respuesta
                    const blob = new Blob([xhr.response], { type: xhr.getResponseHeader('Content-Type') });

                    // Verificar la extensión del archivo
                    if (extension === 'pdf') {
                        // Si es un PDF, abrir en una nueva pestaña
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('target', '_blank');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        // Para otras extensiones, descargar
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nombreArchivo;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            };

            // Enviar la solicitud
            xhr.send();
        },
        // Función para obtener y mostrar los nombres de archivo de los adjuntos del proceso
        async mostrarAdjuntosCategories(id) {
            try {
                const response = await axios.get(`api/Categories/MostrarCategoriesPrison/${id}`);
                switch (id) {
                    case 1:
                        this.nombresAdjuntos = response.data;
                        break;
                    case 2:
                        this.nombresAdjuntos2 = response.data;
                        break;
                    case 3:
                        this.nombresAdjuntos3 = response.data;
                        break;
                    case 4:
                        this.nombresAdjuntos4 = response.data;
                        break;
                    case 5:
                        this.nombresAdjuntos5 = response.data;
                        break;
                    case 6:
                        this.nombresAdjuntos6 = response.data;
                        break;
                    case 7:
                        this.nombresAdjuntos7 = response.data;
                        break;
                    case 8:
                        this.nombresAdjuntos8 = response.data;
                        break;
                    default:
                        console.error("ID no válido:", id);
                        break;
                }
            } catch (error) {
                console.error(error);
                return []; // En caso de error, devuelve una lista vacía o realiza otra acción adecuada
            }
        },
        
        /*
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../../assets/${filename}`);
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 16px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }    
    .document-columns {
        columns: 2; /* Divide la lista en dos columnas */
        column-gap: 20px; /* Espacio entre las columnas */
    }
    table {
        width: 100%;
        border: 1px solid black;
    }
    th, td {
        border: 1px solid black;
        padding: 5px;
        text-align: left;
    }
</style>